<ngb-accordion #acc="ngbAccordion">
  <ngb-panel *ngFor="let facility of facilities">
    <ng-template ngbPanelTitle>
      {{facility.name}}
    </ng-template>
    <ng-template ngbPanelContent>
      <app-faclility-view [facility]="facility"
                          [allFacilities]="allFacilities"></app-faclility-view>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
